// fetchCountries.js
import { message } from "antd";
// import { useSelector } from "react-redux";

export const fetchPincode = async (setPincode, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await fetch(
      `${prodTestUrl ? prodTestUrl : baseUrl}/api/admin-get-all-pincodes/`
    );
    if (response.ok) {
      const data = await response.json();
      setPincode(data); // Update state with fetched countries
    } else {
      message.error("Failed to fetch pincodes.");
    }
  } catch (error) {
    message.error("An error occurred while fetching pincodes.");
  }
};